import '.gs{border-left:4px solid var(--gray-200);}.ssr-plugin'
import '.gt{padding-left:1.5rem;}.ssr-plugin'
import '.gu{margin:1rem 0;}.ssr-plugin'
import '.gv{color:var(--gray-700);}.ssr-plugin'
import '.gw{font-style:italic;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

interface BlockQuoteProps extends PropsWithChildren {
  style?: Style
}

export const BlockQuote = ({ children, style }: BlockQuoteProps) => {
  return (
    <styled.blockquote className="gs gt gu gv gw"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.blockquote>
  )
}
